module.exports = function getResource(label, vars = []) {
    const resources = {
        title: 'Appliquer des récompenses Rouge',
        apply: 'Appliquer',
        applied: 'Appliqué',
        remove: 'Supprimer',
        bopisRougeMessage: 'Seulement admissible dans votre',
        bopisRougeMessageRedirect: 'Panier d’expédition et de livraison',
        rougeRewardsMessage: `<b>${vars[0]} de réduction</b> • Exp. ${vars[1]}`,
        rougeRewardsAppliedMessage: `<b>${vars[0]} de réduction </b> appliqué`
    };

    return resources[label];
};
